// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"0482c7c6","206":"8ec92f61","249":"ccc4663e","339":"6896fe6b","635":"cafc4c94","732":"7f625f9a","826":"5b08c2fe","871":"28dd4f20","954":"b7eeae11"}[chunkId] + ".chunk.js";
};